module.exports = __webpack_public_path__ + "static/media/7 - Futuro Pelo - Swamp.4f52d659.mp3";